export default __webpack_public_path__ + "static/media/consumingflames.4e5e6c92.png";